<template>
  <div class="todo-management-container">
    <!-- 顶部统计卡片 -->
    <div class="stats-cards">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="stat-card total">
            <div class="stat-icon"><i class="el-icon-document"></i></div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.total || 0 }}</div>
              <div class="stat-label">总资质数</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card auditing">
            <div class="stat-icon"><i class="el-icon-time"></i></div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.auditing || 0 }}</div>
              <div class="stat-label">审核中</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card approved">
            <div class="stat-icon"><i class="el-icon-check"></i></div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.approved || 0 }}</div>
              <div class="stat-label">已认证</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card rejected">
            <div class="stat-icon"><i class="el-icon-close"></i></div>
            <div class="stat-content">
              <div class="stat-value">{{ stats.rejected || 0 }}</div>
              <div class="stat-label">已驳回</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 搜索筛选栏 -->
    <el-card class="filter-card">
      <el-form :inline="true" :model="searchParams" class="filter-form">
        <el-form-item label="审核状态">
          <el-select v-model="searchParams.status" placeholder="全部" clearable style="width: 140px">
            <el-option label="待提交" :value="1"></el-option>
            <el-option label="审核中" :value="2"></el-option>
            <el-option label="已认证" :value="3"></el-option>
            <el-option label="已驳回" :value="4"></el-option>
            <el-option label="已过期" :value="5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input v-model="searchParams.companyName" placeholder="请输入公司名称" clearable style="width: 200px" />
        </el-form-item>
        <el-form-item label="营业执照号">
          <el-input v-model="searchParams.businessLicenseNo" placeholder="请输入营业执照号" clearable style="width: 200px" />
        </el-form-item>
        <el-form-item label="提交时间">
          <el-date-picker
              v-model="searchParams.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
              style="width: 260px"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
          <el-button @click="handleReset" icon="el-icon-refresh-right">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 待办列表 -->
    <el-card class="todo-list-card">
      <div v-loading="loading">
        <el-table :data="todoList" border stripe style="width: 100%">
          <el-table-column label="公司信息" min-width="250">
            <template #default="scope">
              <div class="company-info">
                <div class="company-name">
                  <span class="name-text">{{ scope.row.companyName || '-' }}</span>
                  <el-tag size="mini" type="info" style="margin-left: 8px">
                    门店ID: {{ scope.row.merchantId }}
                  </el-tag>
                </div>
                <div class="legal-person">
                  <i class="el-icon-user"></i> 法人：{{ scope.row.legalPerson || '-' }}
                </div>
                <div class="company-address">
                  <i class="el-icon-location"></i> {{ scope.row.registeredAddress || '-' }}
                </div>
                <div class="contact-phone">
                  <i class="el-icon-phone"></i> 联系电话：{{ scope.row.legalPersonPhone || '-' }}
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="营业执照" min-width="200">
            <template #default="scope">
              <div class="license-info">
                <div class="license-no">
                  <span class="label">执照号：</span>
                  <span>{{ scope.row.businessLicenseNo || '-' }}</span>
                </div>
                <div class="license-date">
                  <span class="label">有效期：</span>
                  <span>{{ formatDate(scope.row.businessLicenseExpireDate) || '长期有效' }}</span>
                </div>
                <div class="license-image" v-if="scope.row.businessLicenseImageUrl">
                  <el-image
                      :src="scope.row.businessLicenseImageUrl"
                      fit="cover"
                      style="width: 60px; height: 40px; border-radius: 4px; cursor: pointer"
                      :preview-src-list="[scope.row.businessLicenseImageUrl]"
                      lazy
                      preview-teleported
                  />
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="食品经营许可证" min-width="180">
            <template #default="scope">
              <div v-if="scope.row.foodLicenseNo || scope.row.foodLicenseImageId">
                <div class="license-no">
                  <span class="label">许可证号：</span>
                  <span>{{ scope.row.foodLicenseNo || '-' }}</span>
                </div>
                <div class="license-date">
                  <span class="label">有效期：</span>
                  <span>{{ formatDate(scope.row.foodLicenseExpireDate) || '长期有效' }}</span>
                </div>
                <div class="license-image" v-if="scope.row.foodLicenseImageUrl">
                  <el-image
                      :src="scope.row.foodLicenseImageUrl"
                      fit="cover"
                      style="width: 60px; height: 40px; border-radius: 4px; cursor: pointer"
                      :preview-src-list="[scope.row.foodLicenseImageUrl]"
                      lazy
                      preview-teleported
                  />
                </div>
              </div>
              <span v-else class="no-data">未上传</span>
            </template>
          </el-table-column>

          <el-table-column label="药品经营许可证" min-width="180">
            <template #default="scope">
              <div v-if="scope.row.drugLicenseNo || scope.row.drugLicenseImageId">
                <div class="license-no">
                  <span class="label">许可证号：</span>
                  <span>{{ scope.row.drugLicenseNo || '-' }}</span>
                </div>
                <div class="license-date">
                  <span class="label">有效期：</span>
                  <span>{{ formatDate(scope.row.drugLicenseExpireDate) || '长期有效' }}</span>
                </div>
                <div class="license-image" v-if="scope.row.drugLicenseImageUrl">
                  <el-image
                      :src="scope.row.drugLicenseImageUrl"
                      fit="cover"
                      style="width: 60px; height: 40px; border-radius: 4px; cursor: pointer"
                      :preview-src-list="[scope.row.drugLicenseImageUrl]"
                      lazy
                      preview-teleported
                  />
                </div>
              </div>
              <span v-else class="no-data">未上传</span>
            </template>
          </el-table-column>

          <el-table-column label="法人信息" width="150">
            <template #default="scope">
              <div class="person-info">
                <div>姓名：{{ scope.row.legalPersonName || '-' }}</div>
                <div>身份证：{{ scope.row.legalPersonIdCard ? maskIdCard(scope.row.legalPersonIdCard) : '-' }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="提交时间" width="160" align="center">
            <template #default="scope">
              {{ formatDateTime(scope.row.addDataTime) }}
            </template>
          </el-table-column>

          <el-table-column label="审核状态" width="100" align="center">
            <template #default="scope">
              <el-tag :type="getStatusType(scope.row.status)" size="small">
                {{ getStatusText(scope.row.status) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="200" align="center" fixed="right">
            <template #default="scope">
              <div class="action-buttons" v-if="scope.row.status === 2">
                <el-button type="success" size="mini" @click="handleApprove(scope.row)" icon="el-icon-check">通过</el-button>
                <el-button type="danger" size="mini" @click="handleReject(scope.row)" icon="el-icon-close">拒绝</el-button>
                <el-button type="primary" size="mini" @click="handleViewDetail(scope.row)" icon="el-icon-view">详情</el-button>
              </div>
              <div class="action-buttons" v-else>
                <el-button type="primary" size="mini" @click="handleViewDetail(scope.row)" icon="el-icon-view">详情</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <el-empty v-if="!loading && todoList.length === 0" description="暂无数据" :image-size="200" />

        <div class="pagination-container" v-if="todoList.length > 0">
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagination.total"
              background
          />
        </div>
      </div>
    </el-card>

    <!-- 详情对话框 -->
    <el-dialog
        title="资质审核详情"
        :visible.sync="detailDialog.visible"
        width="900px"
        @close="handleDetailDialogClose"
        append-to-body
        :modal-append-to-body="true"
    >
      <div class="audit-detail" v-if="detailDialog.data">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="营业执照信息" name="license">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="公司名称">
                {{ detailDialog.data.companyName || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="营业执照号">
                {{ detailDialog.data.businessLicenseNo || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="法定代表人">
                {{ detailDialog.data.legalPerson || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="注册地址">
                {{ detailDialog.data.registeredAddress || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="经营范围" :span="2">
                {{ detailDialog.data.businessScope || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="成立日期">
                {{ formatDate(detailDialog.data.establishDate) }}
              </el-descriptions-item>
              <el-descriptions-item label="有效期至">
                {{ formatDate(detailDialog.data.businessLicenseExpireDate) || '长期有效' }}
              </el-descriptions-item>
              <el-descriptions-item label="长期有效">
                {{ detailDialog.data.isLongTerm ? '是' : '否' }}
              </el-descriptions-item>
              <el-descriptions-item label="营业执照" :span="2">
                <div v-if="detailDialog.data.businessLicenseImageUrl" class="image-container">
                  <img
                      :src="detailDialog.data.businessLicenseImageUrl"
                      class="detail-image"
                      @click="previewImage(detailDialog.data.businessLicenseImageUrl)"
                  />
                </div>
                <span v-else>无</span>
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>

          <el-tab-pane label="食品经营许可证" name="food">
            <el-descriptions :column="2" border v-if="detailDialog.data.foodLicenseNo || detailDialog.data.foodLicenseImageId">
              <el-descriptions-item label="许可证号">
                {{ detailDialog.data.foodLicenseNo || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="经营项目" :span="2">
                {{ detailDialog.data.foodBusinessItems || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="有效期至">
                {{ formatDate(detailDialog.data.foodLicenseExpireDate) || '长期有效' }}
              </el-descriptions-item>
              <el-descriptions-item label="长期有效">
                {{ detailDialog.data.foodLicenseIsLongTerm ? '是' : '否' }}
              </el-descriptions-item>
              <el-descriptions-item label="许可证图片" :span="2">
                <div v-if="detailDialog.data.foodLicenseImageUrl" class="image-container">
                  <img
                      :src="detailDialog.data.foodLicenseImageUrl"
                      class="detail-image"
                      @click="previewImage(detailDialog.data.foodLicenseImageUrl)"
                  />
                </div>
                <span v-else>无</span>
              </el-descriptions-item>
            </el-descriptions>
            <el-empty v-else description="未上传食品经营许可证" :image-size="100" />
          </el-tab-pane>

          <el-tab-pane label="药品经营许可证" name="drug">
            <el-descriptions :column="2" border v-if="detailDialog.data.drugLicenseNo || detailDialog.data.drugLicenseImageId">
              <el-descriptions-item label="许可证号">
                {{ detailDialog.data.drugLicenseNo || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="经营范围" :span="2">
                {{ detailDialog.data.drugBusinessScope || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="有效期至">
                {{ formatDate(detailDialog.data.drugLicenseExpireDate) || '长期有效' }}
              </el-descriptions-item>
              <el-descriptions-item label="长期有效">
                {{ detailDialog.data.drugLicenseIsLongTerm ? '是' : '否' }}
              </el-descriptions-item>
              <el-descriptions-item label="许可证图片" :span="2">
                <div v-if="detailDialog.data.drugLicenseImageUrl" class="image-container">
                  <img
                      :src="detailDialog.data.drugLicenseImageUrl"
                      class="detail-image"
                      @click="previewImage(detailDialog.data.drugLicenseImageUrl)"
                  />
                </div>
                <span v-else>无</span>
              </el-descriptions-item>
            </el-descriptions>
            <el-empty v-else description="未上传药品经营许可证" :image-size="100" />
          </el-tab-pane>

          <el-tab-pane label="法人信息" name="person">
            <el-descriptions :column="2" border>
              <el-descriptions-item label="法人姓名">
                {{ detailDialog.data.legalPersonName || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="法人身份证号">
                {{ detailDialog.data.legalPersonIdCard ? maskIdCard(detailDialog.data.legalPersonIdCard) : '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="法人手机号">
                {{ detailDialog.data.legalPersonPhone || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="身份证正面">
                <div v-if="detailDialog.data.idCardFrontImageUrl" class="image-container">
                  <img
                      :src="detailDialog.data.idCardFrontImageUrl"
                      class="detail-image"
                      @click="previewImage(detailDialog.data.idCardFrontImageUrl)"
                  />
                </div>
                <span v-else>无</span>
              </el-descriptions-item>
              <el-descriptions-item label="身份证反面">
                <div v-if="detailDialog.data.idCardBackImageUrl" class="image-container">
                  <img
                      :src="detailDialog.data.idCardBackImageUrl"
                      class="detail-image"
                      @click="previewImage(detailDialog.data.idCardBackImageUrl)"
                  />
                </div>
                <span v-else>无</span>
              </el-descriptions-item>
              <el-descriptions-item label="手持身份证" :span="2">
                <div v-if="detailDialog.data.legalPersonHandheldImageUrl" class="image-container">
                  <img
                      :src="detailDialog.data.legalPersonHandheldImageUrl"
                      class="detail-image"
                      @click="previewImage(detailDialog.data.legalPersonHandheldImageUrl)"
                  />
                </div>
                <span v-else>无</span>
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>

          <el-tab-pane label="其他资质" name="other">
            <el-descriptions :column="1" border>
              <el-descriptions-item label="其他资质说明">
                {{ detailDialog.data.otherQualificationDesc || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="其他资质文件" v-if="detailDialog.data.otherQualificationImageUrls && detailDialog.data.otherQualificationImageUrls.length">
                <div class="other-images">
                  <div
                      v-for="(url, idx) in detailDialog.data.otherQualificationImageUrls"
                      :key="idx"
                      class="image-item"
                  >
                    <img
                        :src="url"
                        class="other-image"
                        @click="previewImage(url)"
                    />
                  </div>
                </div>
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>

          <el-tab-pane label="审核记录" name="audit">
            <el-descriptions :column="1" border>
              <el-descriptions-item label="审核状态">
                <el-tag :type="getStatusType(detailDialog.data.status)" size="small">
                  {{ getStatusText(detailDialog.data.status) }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="提交时间">
                {{ formatDateTime(detailDialog.data.addDataTime) }}
              </el-descriptions-item>
              <el-descriptions-item label="最后更新时间">
                {{ formatDateTime(detailDialog.data.lastUpdateTime) }}
              </el-descriptions-item>
              <el-descriptions-item label="审核时间" v-if="detailDialog.data.auditTime">
                {{ formatDateTime(detailDialog.data.auditTime) }}
              </el-descriptions-item>
              <el-descriptions-item label="驳回原因" v-if="detailDialog.data.rejectReason">
                {{ detailDialog.data.rejectReason }}
              </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" v-if="detailDialog.data?.status === 2">
        <el-button @click="detailDialog.visible = false">取消</el-button>
        <el-button type="success" @click="handleApproveFromDetail">通过</el-button>
        <el-button type="danger" @click="handleRejectFromDetail">拒绝</el-button>
      </span>
      <span slot="footer" v-else>
        <el-button type="primary" @click="detailDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 图片预览对话框 -->
    <el-dialog
        title="图片预览"
        :visible.sync="previewDialog.visible"
        width="80%"
        append-to-body
        :modal-append-to-body="true"
    >
      <div class="preview-container">
        <img :src="previewDialog.url" class="preview-image" />
      </div>
      <span slot="footer">
        <el-button type="primary" @click="previewDialog.visible = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 审核对话框 -->
    <el-dialog
        :title="auditDialog.title"
        :visible.sync="auditDialog.visible"
        width="450px"
        append-to-body
        :modal-append-to-body="true"
        @close="handleAuditDialogClose"
    >
      <el-form :model="auditDialog.form" label-width="100px">
        <el-form-item label="驳回原因" v-if="auditDialog.type === 'reject'">
          <el-input
              v-model="auditDialog.form.rejectReason"
              type="textarea"
              :rows="4"
              placeholder="请输入驳回原因..."
              maxlength="500"
              show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="auditDialog.visible = false">取消</el-button>
        <el-button
            type="primary"
            @click="confirmAudit"
            :loading="auditDialog.loading"
        >
          {{ auditDialog.type === 'approve' ? '确认通过' : '确认拒绝' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/utils/api";

export default {
  name: 'TodoManagement',
  data() {
    return {
      loading: false,
      activeTab: 'license',
      searchParams: {
        status: '',
        companyName: '',
        businessLicenseNo: '',
        dateRange: []
      },
      stats: {
        total: 0,
        auditing: 0,
        approved: 0,
        rejected: 0
      },
      todoList: [],
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      detailDialog: {
        visible: false,
        data: null
      },
      previewDialog: {
        visible: false,
        url: ''
      },
      auditDialog: {
        visible: false,
        title: '',
        type: '',
        loading: false,
        form: {
          id: null,
          merchantId: null,
          rejectReason: ''
        }
      }
    }
  },
  mounted() {
    this.loadTodoList();
    this.loadStats();
  },
  methods: {
    // 加载待办列表
    async loadTodoList() {
      this.loading = true;
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize,
          status: this.searchParams.status,
          companyName: this.searchParams.companyName,
          businessLicenseNo: this.searchParams.businessLicenseNo,
          startTime: this.searchParams.dateRange?.[0],
          endTime: this.searchParams.dateRange?.[1]
        };

        const response = await api.todo_getQualificationList(params);
        const responseData = response.data || response;

        if (responseData.code === "000" && responseData.data) {
          this.todoList = responseData.data.records || responseData.data.list || [];
          this.pagination.total = responseData.data.total || 0;
        } else {
          this.$message.error(responseData.message || '加载失败');
        }
      } catch (error) {
        console.error('加载待办列表失败:', error);
        this.$message.error('加载失败');
      } finally {
        this.loading = false;
      }
    },

    // 加载统计数据
    async loadStats() {
      try {
        const response = await api.todo_getQualificationStats();
        const responseData = response.data || response;

        if (responseData.code === "000" && responseData.data) {
          this.stats = {
            total: responseData.data.total || 0,
            auditing: responseData.data.auditing || 0,
            approved: responseData.data.approved || 0,
            rejected: responseData.data.rejected || 0
          };
        }
      } catch (error) {
        console.error('加载统计数据失败:', error);
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.page = 1;
      this.loadTodoList();
      this.loadStats();
    },

    // 重置搜索
    handleReset() {
      this.searchParams = {
        status: '',
        companyName: '',
        businessLicenseNo: '',
        dateRange: []
      };
      this.pagination.page = 1;
      this.loadTodoList();
      this.loadStats();
    },

    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.page = 1;
      this.loadTodoList();
    },

    // 页码变化
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.loadTodoList();
    },

    // 查看详情
    handleViewDetail(row) {
      this.detailDialog.data = row;
      this.detailDialog.visible = true;
      this.activeTab = 'license';
    },

    // 预览图片
    previewImage(url) {
      this.previewDialog.url = url;
      this.previewDialog.visible = true;
    },

    // 通过审核
    handleApprove(row) {
      this.auditDialog = {
        visible: true,
        title: '资质审核 - 通过',
        type: 'approve',
        loading: false,
        form: {
          id: row.id,
          merchantId: row.merchantId,
          rejectReason: ''
        }
      };
    },

    // 从详情页通过
    handleApproveFromDetail() {
      const data = this.detailDialog.data;
      this.detailDialog.visible = false;
      this.handleApprove(data);
    },

    // 拒绝审核
    handleReject(row) {
      this.auditDialog = {
        visible: true,
        title: '资质审核 - 拒绝',
        type: 'reject',
        loading: false,
        form: {
          id: row.id,
          merchantId: row.merchantId,
          rejectReason: ''
        }
      };
    },

    // 从详情页拒绝
    handleRejectFromDetail() {
      const data = this.detailDialog.data;
      this.detailDialog.visible = false;
      this.handleReject(data);
    },

    // 确认审核
    async confirmAudit() {
      if (this.auditDialog.type === 'reject' && !this.auditDialog.form.rejectReason) {
        this.$message.warning('请填写驳回原因');
        return;
      }

      this.auditDialog.loading = true;
      try {
        let response;
        if (this.auditDialog.type === 'approve') {
          response = await api.todo_approveQualification({
            id: this.auditDialog.form.id
          });
        } else {
          response = await api.todo_rejectQualification({
            id: this.auditDialog.form.id,
            rejectReason: this.auditDialog.form.rejectReason
          });
        }

        const responseData = response.data || response;

        if (responseData.code === "000") {
          this.$message.success(this.auditDialog.type === 'approve' ? '审核通过成功' : '已拒绝');
          this.auditDialog.visible = false;
          this.loadTodoList();
          this.loadStats();
        } else {
          this.$message.error(responseData.message || '操作失败');
        }
      } catch (error) {
        console.error('审核失败:', error);
        this.$message.error('操作失败');
      } finally {
        this.auditDialog.loading = false;
      }
    },

    // 关闭详情对话框
    handleDetailDialogClose() {
      this.detailDialog.data = null;
      this.activeTab = 'license';
    },

    // 关闭审核对话框
    handleAuditDialogClose() {
      this.auditDialog.form = {
        id: null,
        merchantId: null,
        rejectReason: ''
      };
    },

    // 身份证号脱敏
    maskIdCard(idCard) {
      if (!idCard) return '-';
      if (idCard.length === 18) {
        return idCard.substring(0, 6) + '********' + idCard.substring(14);
      }
      if (idCard.length === 15) {
        return idCard.substring(0, 6) + '******' + idCard.substring(12);
      }
      return idCard;
    },

    // 获取状态标签类型
    getStatusType(status) {
      const types = {
        1: 'info',
        2: 'warning',
        3: 'success',
        4: 'danger',
        5: 'info'
      };
      return types[status] || 'info';
    },

    // 获取状态文本
    getStatusText(status) {
      const texts = {
        1: '待提交',
        2: '审核中',
        3: '已认证',
        4: '已驳回',
        5: '已过期'
      };
      return texts[status] || '未知';
    },

    // 格式化日期（只显示年月日）
    formatDate(timestamp) {
      if (!timestamp) return '-';
      try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '-';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      } catch (error) {
        return '-';
      }
    },

    // 格式化日期时间（显示年月日时分秒）
    formatDateTime(timestamp) {
      if (!timestamp) return '-';
      try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '-';
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hour = String(date.getHours()).padStart(2, '0');
        const minute = String(date.getMinutes()).padStart(2, '0');
        const second = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      } catch (error) {
        return '-';
      }
    }
  }
}
</script>

<style scoped>
.todo-management-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.stats-cards {
  margin-bottom: 20px;
}

.stat-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  height: 100px;
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  font-size: 28px;
}

.stat-card.total .stat-icon {
  background-color: #e6f7ff;
  color: #1890ff;
}

.stat-card.auditing .stat-icon {
  background-color: #fff7e6;
  color: #fa8c16;
}

.stat-card.approved .stat-icon {
  background-color: #f6ffed;
  color: #52c41a;
}

.stat-card.rejected .stat-icon {
  background-color: #fff2f0;
  color: #f56c6c;
}

.stat-content {
  flex: 1;
}

.stat-value {
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 4px;
}

.stat-label {
  font-size: 14px;
  color: #666;
}

.filter-card {
  margin-bottom: 20px;
  border-radius: 8px;
}

.filter-form {
  margin-bottom: 0;
}

.todo-list-card {
  border-radius: 8px;
}

.company-info {
  line-height: 1.8;
}

.company-name .name-text {
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.legal-person,
.company-address,
.contact-phone {
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.license-info,
.person-info {
  font-size: 12px;
  line-height: 1.8;
}

.license-info .label,
.person-info .label {
  color: #999;
}

.license-image {
  margin-top: 5px;
}

.no-data {
  color: #c0c4cc;
  font-size: 12px;
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}

.audit-detail {
  max-height: 500px;
  overflow-y: auto;
}

.other-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.image-container {
  text-align: center;
}

.detail-image {
  max-width: 100%;
  max-height: 300px;
  border-radius: 4px;
  cursor: pointer;
}

.other-image {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ebeef5;
}

.other-image:hover {
  opacity: 0.8;
}

.preview-container {
  text-align: center;
}

.preview-image {
  max-width: 100%;
  max-height: 70vh;
}

.image-item {
  display: inline-block;
}
</style>

<style>
/* 全局样式 */
.el-dialog__wrapper {
  z-index: 2000 !important;
}

.el-message-box__wrapper {
  z-index: 2100 !important;
}

.el-select-dropdown {
  z-index: 2200 !important;
}

.el-popper {
  z-index: 2200 !important;
}

.el-loading-mask {
  z-index: 1900 !important;
}

.el-dropdown-menu {
  z-index: 2100 !important;
}

.v-modal {
  z-index: 1999 !important;
}
</style>